import { render, staticRenderFns } from "./aboutNew.vue?vue&type=template&id=18e09473&"
import script from "./aboutNew.vue?vue&type=script&lang=js&"
export * from "./aboutNew.vue?vue&type=script&lang=js&"
import style0 from "./aboutNew.vue?vue&type=style&index=0&id=18e09473&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports